import {useState} from 'react';

import {
	makePatchExamsConfirmBooked,
	makePatchHealthConfirmAppointments,
	makePatchOdontoConfirmBooked,
} from 'main/factories/usecases';
import {OperationStateType, OperationStateTypesEnum} from 'presentation/constants';
import {useGetHomeQuery} from '../../home/query/useGetHomeQuery';
import {EntryPointCodeEnum} from '../constants';
import {usePostSurgeryConfirmMutation} from 'presentation/modules/myAppointments/mutations/usePostSurgeryConfirmMutation';
import {SurgeryConfirmActionEnum} from 'domain/usecases/private/booking-flow/surgery/post-surgery-confirm';

export function useConfirmBooking() {
	const [confirmState, setConfirmState] = useState<OperationStateType | null>(null);
	const {refetch: refetchHome} = useGetHomeQuery();
	const {mutateAsync: mutateConfirmSurgery} = usePostSurgeryConfirmMutation();

	const isError = confirmState === OperationStateTypesEnum.ERROR;
	const isPending = confirmState === OperationStateTypesEnum.PENDING;
	const isDone = confirmState === OperationStateTypesEnum.DONE;
	const isSubmitting = confirmState === OperationStateTypesEnum.SUBMITTING;

	async function handleConfirmOperation() {
		await refetchHome();
		setConfirmState(OperationStateTypesEnum.DONE);
	}

	async function confirmHealth(bookingNumber: string) {
		try {
			setConfirmState(OperationStateTypesEnum.SUBMITTING);

			await makePatchHealthConfirmAppointments().patch({
				number: bookingNumber,
				confirmationFlag: 'S',
				entryPointCode: EntryPointCodeEnum.V2,
			});

			handleConfirmOperation();
		} catch (error) {
			setConfirmState(OperationStateTypesEnum.ERROR);
		}
	}

	async function confirmOdonto(bookingNumber: string) {
		try {
			setConfirmState(OperationStateTypesEnum.SUBMITTING);

			await makePatchOdontoConfirmBooked().patch({
				nuConsulta: bookingNumber,
				flagConfirmado: 'S',
				cdPontoEntrada: EntryPointCodeEnum.V1,
			});
			handleConfirmOperation();
		} catch (error) {
			setConfirmState(OperationStateTypesEnum.ERROR);
		}
	}

	async function confirmExam(bookingNumber: string) {
		try {
			setConfirmState(OperationStateTypesEnum.SUBMITTING);

			await makePatchExamsConfirmBooked().patch({
				nuExame: bookingNumber,
				flConfirmado: 'S',
				cdPontoEntrada: EntryPointCodeEnum.V1,
			});
			handleConfirmOperation();
		} catch (error) {
			setConfirmState(OperationStateTypesEnum.ERROR);
		}
	}

	const confirmSurgery = async (scheduleCode: number) => {
		try {
			setConfirmState(OperationStateTypesEnum.SUBMITTING);
			await mutateConfirmSurgery({
				scheduleCode,
				option: SurgeryConfirmActionEnum.CONFIRM,
			});
			handleConfirmOperation();
		} catch {
			setConfirmState(OperationStateTypesEnum.ERROR);
		}
	};

	return {
		confirmHealth,
		confirmExam,
		confirmOdonto,
		isError,
		isPending,
		isDone,
		isSubmitting,
		setConfirmState,
		confirmSurgery,
	};
}
